import { client as baseClient } from './baseApi/client'

export type * from './baseApi/client'

export const clientApi = baseClient.enhanceEndpoints({
  addTagTypes: ['Client'],
  endpoints: {
    getClientsById: {
      providesTags: (_result, _error, arg) => [{ type: 'Client', id: arg.id }],
    },
    getClientsByIdSettings: {
      // The portal-availability rollout requires the v3.0 contract of this
      // endpoint; the generated default (baseQuery.ts) falls back to v1.0.
      query: (queryArg) => ({
        url: `/client/Clients/${queryArg.id}/settings`,
        headers: { 'x-api-version': '3.0' },
      }),
    },
    putClientsByIdAdvisorportalaccess: {
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Client', id: arg.id },
      ],
    },
  },
})

export const {
  useGetClientsByIdQuery,
  useGetClientsQueryQuery,
  useGetClientsQuery,
  useGetClientsByIdDocumentsQuery,
  useGetClientsByIdDocumentsAndDocumentIdDownloadQuery,
  useGetClientsByIdPrivacystatementQuery,
  useGetClientsByIdSettingsQuery,
  usePostPortalusersMutation,
  useGetPortalusersSummaryQuery,
  usePutContactsAndNameIdMutation,
  useGetContactsAndNameIdUnitsQuery,
  usePostContactsQueryMutation,
  usePostOthercontactsQueryMutation,
  usePostBoardcontactsQueryMutation,
  useGetBoardcontactsAndIdQuery,
  usePutBoardcontactsAndIdMutation,
  useDeleteBoardcontactsAndIdMutation,
  usePostBoardcontactsMutation,
  usePostObjectcontactsQueryMutation,
  usePostMetercontactsQueryMutation,
  useGetObjecttypesQuery,
  useGetMetertypesQuery,
  useGetClientsByClientNoActiveinfoQuery,
  usePutClientsByIdAdvisorportalaccessMutation,
  useGetClientsByClientNoOwnersQuery,
  useGetMinimizedClientsQuery,
  useGetBblcontactsQuery,
  usePutContactsAndNameIdElectroniccommunicationMutation,
} = clientApi
